import React from 'react';
import Signup from 'components/Signup';
import useInstanceConfig from 'modules/siteConfig/hooks/useInstanceConfig';
import { GetStaticProps } from 'next';
import { NextSeo } from 'next-seo';
import getStaticPathsSite from 'utils/getStaticPathsSite';

export default function SignupPage() {
  const { site }: TSFixMe = useInstanceConfig();
  const title = 'Sign Up';
  const url = `https://${site.host}/signup`;
  const { siteName } = site.seo;
  const description = `Sign Up Page for ${siteName}`;

  return (
    <>
      <Signup />
      <NextSeo
        canonical={url}
        description={description}
        openGraph={{
          title,
          description,
          site_name: siteName,
          type: 'website',
        }}
        title={title}
        twitter={{
          site: site.seo.twitterHandle,
          cardType: 'summary_large_image',
        }}
      />
    </>
  );
}

export { getStaticPathsSite as getStaticPaths };

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
    revalidate: 180,
  };
};
